import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import TokenAddModal from "../partials/TokenAddModal";

import { toast, ToastContainer } from "react-toastify";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";

class Tokens extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        key: "file",
        text: "logoURI",
        className: "logoURI",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <img src={`${record.file}`} width={50} alt="form" />;
        },
      },
      {
        key: "name",
        text: "Name",
        className: "name",
        align: "left",
        sortable: true,
      },
      {
        key: "symbol",
        text: "Symbol",
        className: "symbol",
        align: "left",
        sortable: true,
      },
      {
        key: "decimal",
        text: "Decimal",
        className: "decimals",
        align: "left",
        sortable: true,
      },
      {
        key: "address",
        text: "Address",
        className: "addresses",
        align: "left",
        sortable: true,
      },
      {
        key: "action",
        text: "Action",
        className: "action",
        width: 100,
        align: "left",
        sortable: false,
        cell: (record) => {
          return (
            <Fragment>
              {/* <button
                                data-toggle="modal"
                                data-target="#update-form-modal"
                                className="btn btn-primary btn-sm"
                                onClick={() => this.editRecord(record)}
                                style={{marginRight: '5px'}}>
                                <i className="fa fa-edit"></i>
                            </button> */}
              <button
                className="btn btn-danger btn-sm"
                onClick={() => this.deleteRecord(record)}
              >
                <i className="fa fa-trash"></i>
              </button>
            </Fragment>
          );
        },
      },
    ];

    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "Tokens",
      no_data_text: "No Tokens found!",
      button: {
        excel: true,
        print: true,
        csv: true,
      },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };

    this.state = {
      records: [],
    };

    this.state = {
      currentRecord: {
        name: "",
        symbol: "",
        addresses: "",
        chainId: "",
        decimals: "",
        file: {},
      },
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    this.getData();
  }

  async getData() {
    const querySnapshot = await getDocs(collection(db, "tokens"));
    let docs = [];
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      docs.push(doc.data());
    });
    this.setState({ records: docs });
    // axios
    //     .get(`/token/listToken`)
    //     .then(res => {
    //         this.setState({ records: res.data.data})
    //         console.log(res.data)
    //     })
    //     .catch()
  }

  editRecord(record) {
    this.setState({ currentRecord: record });
  }

  async deleteRecord(record) {
    await deleteDoc(doc(db, "tokens", record.id));
    toast("The token has been deleted", {
      position: toast.POSITION.TOP_CENTER,
    });
    // axios
    //     .post("/token/deleteToken", {id: record.id})
    //     .then(res => {
    //         if (res.status === 200) {
    //            toast(res.data.message, {
    //                position: toast.POSITION.TOP_CENTER,
    //            })
    //         }
    //     })
    //     .catch();
    this.getData();
  }

  pageChange(pageData) {
    console.log("OnPageChange", pageData);
  }

  render() {
    return (
      <div>
        <Navbar />
        <div className="d-flex" id="wrapper">
          <Sidebar />
          <TokenAddModal />
          {/* <TokenUpdateModal record={this.state.currentRecord}/> */}
          <div id="page-content-wrapper">
            <div className="container-fluid">
              <button className="btn btn-link mt-3" id="menu-toggle">
                <FontAwesomeIcon icon={faList} />
              </button>
              <button
                className="btn btn-outline-primary float-right mt-3 mr-2"
                data-toggle="modal"
                data-target="#add-token-modal"
              >
                <FontAwesomeIcon icon={faPlus} /> Add Token
              </button>
              <h1 className="mt-2 text-primary">Tokens</h1>
              <ReactDatatable
                config={this.config}
                records={this.state.records}
                columns={this.columns}
                onPageChange={this.pageChange.bind(this)}
              />
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    );
  }
}

Tokens.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  records: state.records,
});

export default connect(mapStateToProps)(Tokens);
